import { LanguageCurrencyPicker } from "@aurem/components";
import { useLanguageSwitcher } from "../../hooks/useLanguageSwitcher";
import { useCurrency } from "../../providers/CurrencyProvider";

export const LanguageCurrencyToggle = () => {
  const { languageOptions, currentLanguage, handleLanguageChange } =
    useLanguageSwitcher();
  const { currenciesTranslated, currentCurrency, setCurrency } = useCurrency();

  return (
    <LanguageCurrencyPicker
      languages={languageOptions}
      currencies={currenciesTranslated}
      currentLanguage={currentLanguage}
      currentCurrency={currentCurrency}
      onLanguageSelect={handleLanguageChange}
      onCurrencySelect={setCurrency}
    />
  );
};
